function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#2D2D2D"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8 1.078a6.922 6.922 0 100 13.844A6.922 6.922 0 008 1.078zM0 8a8 8 0 1116 0A8 8 0 010 8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 4c.246 0 .445.206.445.46v.277c.68.09 1.291.385 1.671.838a.471.471 0 01-.044.649.435.435 0 01-.628-.046c-.191-.227-.544-.429-.999-.51v1.9c.473.063.907.224 1.255.464.451.31.8.791.8 1.384 0 .593-.349 1.073-.8 1.384-.348.24-.782.4-1.255.463v.277c0 .254-.2.46-.445.46a.453.453 0 01-.445-.46v-.277c-.68-.09-1.291-.385-1.671-.838a.471.471 0 01.044-.649.435.435 0 01.628.046c.191.228.544.429.999.51v-1.9A2.882 2.882 0 016.3 7.967c-.451-.31-.8-.791-.8-1.384 0-.593.349-1.073.8-1.384.348-.24.782-.4 1.255-.463V4.46c0-.254.2-.46.445-.46zm-.445 1.667a1.963 1.963 0 00-.761.299c-.292.201-.404.429-.404.618 0 .19.112.417.404.618.198.136.458.244.76.299V5.667zm.89 2.832v1.833c.303-.054.563-.162.761-.298.292-.201.404-.429.404-.618 0-.19-.112-.417-.404-.618a1.963 1.963 0 00-.76-.299z"
}));
function SvgMoneda(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Moneda.svg";
export { SvgMoneda as ReactComponent };